<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/subprogram' }">
        <app-i18n code="entities.subprogram.menu"></app-i18n>
      </el-breadcrumb-item>
      
      <el-breadcrumb-item>
        <app-i18n code="entities.subprogram.edit.title" v-if="isEditing"></app-i18n>
        <app-i18n code="entities.subprogram.new.title" v-if="!isEditing"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Back Button -->
    <app-back-button
      i18n-code="common.back.default"
    />

    <!-- <app-back-button
      class="stripe-connected-account-form-page__header__back"
      route-name="programList"
      :route-params="{ manage, type: programType }"
      :i18n-code="!isPropertyNBA ? 'entities.program.label.many' : 'entities.season.label'"
      /> -->

    <!-- Title -->
    <h1 class="app-content-title">
      <app-i18n v-if="!isEditing" :code="!isPropertyNBA ? 'entities.category.new.title' : 'programs.league.new'"></app-i18n>
      <app-i18n v-if="isEditing" :code="!isPropertyNBA ? 'entities.category.edit.title' : 'programs.league.edit'"></app-i18n>
    </h1>
    
    <div class="app-content-page">
      <div class="app-page-spinner" v-if="findLoading || newIdLoading" v-loading="findLoading || newIdLoading"></div>

      <!-- SUBPROGRAM FORM -->
      <subprogram-form 
        :id="id" 
        :manage="manage" 
        :propertyId="propertyId" 
        :subpropertyId="subpropertyId"
        :programId="programId"
        :programType="programType"
        />
    </div>
  </div>
</template>

<script>
import SubprogramForm from '@modules/subprogram/components/subprogram-form';
import { mapGetters } from 'vuex';

export default {
  name: 'SubprogramFormPage',

  props: {
    id: {
      type: String,
    },
    manage: {
      type: Object,
    },
    typeProgram:  {
      type: String
    },
    propertyId: String,
    subpropertyId: String,
    programId: String,
    programType: String
  },
    computed: {
    ...mapGetters({
      findLoading: 'subprogram/form/findLoading',
      newIdLoading: 'subprogram/form/newIdLoading',
      isPropertyNBA: 'auth/manage/isPropertyNBA',
    }),

    isEditing() {
      return !!this.id;
    },
  },

  components: {
    SubprogramForm,
  },
};
</script>

<style>
</style>
